export default __webpack_public_path__ + "3cd0ffe32a1df46701bfa2f6f32b6ed9.png";